import React from 'react';

import './ModalFileNotFond.scss';
import { Trans, useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';

type Props = {
  setModalNotFile: (e: boolean) => void;
  name?: string;
};
const ModalFileNotFond: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="modal_file_not_fond">
      <div className="close-modal" onClick={() => props.setModalNotFile(false)}><FontAwesomeIcon icon={faClose} /></div>
      <div className="text">
        <span> < Trans i18nKey="_price_not_fond_message" values={{ name: props.name }} components={{ b: <strong /> }} /></span>
        <p >  {t('_price_not_fond_message_back')}</p>
      </div>

    </div>
  );
};

ModalFileNotFond.displayName = 'ModalFileNotFond';

export default ModalFileNotFond;
